<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>

<section>
  <div class="mar-tb-20 pad-lr-30 col-md-6">
    <span class="dta_title">Vendors With Packages:</span>
    <a href="#">All</a> /
    <a href="#">Total</a> /
    <a href="#">Sub-Total</a>
  </div>

  <div class="row no-mar-lr">
    <div class="col-md-10 mar-lft-20">
      <table class="table table-white table-bordered">
        <thead class="greyBg">
          <tr>
            <th scope="col">Supplier</th>
            <th scope="col">Supplier Name</th>
            <th scope="col">Location</th>
            <th scope="col">June Cycle</th>
            <th scope="col">Sum Order of No Packaging</th>
            <th scope="col">Sum of Total Order Quantity</th>
            <th scope="col">Total Order m3</th>
            <th scope="col">Total KG</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td class="hasLink" routerLink="/poDaily">18081</td>
            <td>14</td>
            <td>230</td>
            <td>0.121</td>
            <td>22.6</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>18081</td>
            <td>10</td>
            <td>576</td>
            <td>0.324</td>
            <td>66.8</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>18081</td>
            <td>14</td>
            <td>1533</td>
            <td>0.932</td>
            <td>188.5</td>
          </tr>

        </tbody>
        <tfoot class="greyBg">
          <th>Total</th>
          <th></th>
          <th></th>
          <th></th>
          <th>38</th>
          <th>2339</th>
          <th>1.38</th>
          <th>277.09</th>
        </tfoot>
      </table>
    </div>
  </div>
</section>